import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isLocalStorageSupported, setLocal, getLocal } from 'apis/persist'
import { getComponentDisplayName } from '../utils'

const LOCALKEY = 'LOCALVEHICLE'

// This higher order component is used for saving vehicle options to cookie and read it somewhere else
export default () => (Wrapped) => {
  class LocalVehicle extends Component {
    constructor(props) {
      super(props)
      this.localStorageSupported = isLocalStorageSupported()

      this.state = {
        details: this.getVehicle(props.nameplate || '')
      }
    }

    static propTypes = {
      nameplate: PropTypes.string.isRequired
    }

    static defaultProps = {
      nameplate: ''
    }

    getVehicle = (nameplate) => {
      if (this.localStorageSupported) {
        const vehicles = this.getVehicles() || {}
        const vehicle = vehicles[nameplate.toUpperCase()]
        if (vehicle) return vehicle
      }
    }

    getVehicles = () => {
      const data = getLocal(LOCALKEY)
      if (typeof data === 'string') {
        return JSON.parse(data)
      }
    }

    setVehicle = value => setLocal(LOCALKEY, JSON.stringify(value))

    updateVehicle = (nameplate, params) => this.setVehicle({ [nameplate.toUpperCase()]: params })

    render() {
      return (
        <Wrapped
          {...{
            ...this.props,
            localVehicle: {
              details: this.state.details,
              updateVehicle: this.updateVehicle
            }
          }} />
      )
    }
  }

  LocalVehicle.displayName = `LocalVehicle(${getComponentDisplayName(Wrapped)})`

  return LocalVehicle
}



// WEBPACK FOOTER //
// ./src/higher-order-components/local-vehicle.jsx